<template>
  <BaseVeeForm :action="submit" v-slot="formProps" @success="closeModal">
    <VModal ref="modal" disable-backdrop-click @close="$emit('close')">
      <div class="mx-auto bg-white rounded-lg text-left shadow-xl lg:max-w-lg sm:w-full">
        <div class="flex flex-col divide-y">
          <div class="flex-none p-4">
            <div class="flex justify-between items-center">
              <div class="flex-1">Funnel Stage</div>
              <div class="flex-none">
                <button
                  type="button"
                  class="rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                  @click="closeModal"
                >
                  <span class="sr-only">Close</span>
                  <svg
                    class="inline-flex h-6 w-6"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>
          <div class="flex-1 p-4 space-y-8">
            <BaseFormTextFieldWithValidator
              v-model="formData.name"
              :validator="{
                name: 'name',
                vid: 'name',
                rules: {
                  required: true,
                },
              }"
              :field="{
                label: 'Name',
                id: 'funnel_stage_name',
              }"
              :disabled="formProps.isPending"
            />
            <BaseFormTextareaFieldWithValidator
              v-model="formData.description"
              :validator="{
                name: 'description',
                vid: 'description',
                rules: {
                  required: false,
                },
              }"
              :field="{
                label: 'Description',
                id: 'funnel_stage_description',
              }"
              :disabled="formProps.isPending"
            />
            <BaseFormGroup>
              <BaseFormLabel> Stage audiences </BaseFormLabel>
              <div class="space-y-2">
                <AudienceSelect v-model="formData.audiences" :account-id="accountId" />
                <AudienceList v-model="formData.audiences" />
              </div>
            </BaseFormGroup>
            <div class="flex space-x-2">
              <BaseButton primary> Save </BaseButton>
              <BaseButton type="button" ghost @click="$refs.modal.close()"> Cancel </BaseButton>
            </div>
          </div>
        </div>
      </div>
    </VModal>
  </BaseVeeForm>
</template>

<script>
import AudienceSelect from './AudienceSelect.vue';
import AudienceList from './AudienceList.vue';

export default {
  name: 'FunnelStageModal',
  components: {
    AudienceSelect,
    AudienceList,
  },
  props: {
    action: {
      type: Function,
      default: () => {},
    },
    accountId: {
      type: String,
      required: true,
    },
    funnelStage: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      formData: {
        name: '',
        description: '',
        audiences: [],
      },
    };
  },
  created() {
    this.setupInitialData();
  },
  methods: {
    setupInitialData() {
      Object.keys(this.formData).forEach((prop) => {
        if (prop in this.funnelStage === false) {
          return;
        }

        this.formData[prop] = this.funnelStage[prop];
      });
    },
    async submit() {
      try {
        await this.action({
          ...this.formData,
          audiences: this.formData.audiences.map((audience) => audience.id),
        });

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
    closeModal() {
      this.$refs.modal.close();
    },
  },
};
</script>
